export const alarmCategories = [
    {
        name: 'Cabinet Out of Service',
        types: [
            {
                type: 'EXPIRED_PRODUCT',
                label: 'Expired products in cabinet',
                severity: 'OoS',
            },
            {
                type: 'TAG_CHANGES',
                label: 'Too many bad tags appeared in the cabinet',
                severity: 'OoS',
            },
            {
                type: 'UI_IS_DOWN',
                label: 'Cabinet screen is not working',
                severity: 'OoS',
            },
            {
                type: 'READER_IS_DOWN',
                label: 'RFID reader in the cabinet is not working',
                severity: 'OoS',
            },
            {
                type: 'ANTENNA_DISCONNECTED',
                label: 'RFID antenna in cabinet is disconnected',
                severity: 'OoS',
            },
            {
                type: 'ANTENNA_DOWN',
                label: 'RFID antenna in cabinet is not working',
                severity: 'OoS',
            },
            {
                type: 'READER_CONFIG_ERROR',
                label: 'RFID reader configuration failed and it is not working',
                severity: 'OoS',
            },
            {
                type: 'DEVICE_STATUS',
                label: 'Device Online/Offline status',
                severity: 'OoS',
            },
            {
                type: 'DIGITWIN_STATUS',
                label: "Device's Digitwin Online/Offline status",
                severity: 'OoS',
            },
            {
                type: 'MYPOS_DEVICE_DISCONNECTED',
                label: 'myPOS payment device is disconnected',
                severity: 'OoS',
            },
            {
                type: 'MYPOS_DEVICE_COMMUNICATION_ERROR',
                label: 'myPOS payment device is connected but reporting error',
                severity: 'OoS',
            },
            {
                type: 'CABINET_STATUS_IS_OOS_PAYMENT_PROVIDER',
                label: 'Payment provider is out of service',
                severity: 'OoS',
            },            
            {
                type: 'NAYAX_DEVICE_NOT_READY',
                label: 'Nayax payment device is not ready',
                severity: 'OoS',
            },
        ],
    },
    {
        name: 'Food Safety',
        types: [
            {
                type: 'EXPIRING_PRODUCT',
                label: 'Product in cabinet is expiring (Critical priority)',
                severity: 'Critical',
            },
            {
                type: 'EXPIRING_PRODUCT',
                label: 'Expiring products in cabinets (Informative priority)',
                severity: 'Informative',
            },
            {
                type: 'EXPIRED_PRODUCT',
                label: 'Expired products in cabinets (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'EXPIRED_PRODUCT',
                label: 'Expired products in cabinets (Urgent priority)',
                severity: 'Urgent',
            },
            {
                type: 'TEMPERATURE_SENSOR_ERROR',
                label: 'Temperature sensor in cabinet has error (Critical priority)',
                severity: 'Critical',
            },
            {
                type: 'TEMPERATURE_STAYED_UNDER_MINIMUM',
                label: "Cabinet's temperature stayed under minimum temperature setting for too long (Critical priority)",
                severity: 'Critical',
            },
            {
                type: 'TEMPERATURE_STAYED_OVER_MAXIMUM',
                label: "Cabinet's Temperature stayed over maximum temperature setting for too long (Critical priority)",
                severity: 'Critical',
            },
        ],
    },
    {
        name: 'Products Status',
        types: [
            {
                type: 'UNENCODED_TAG',
                label: 'Unencoded tags available in cabinets inventory (Critical priority)',
                severity: 'Critical',
            },
            {
                type: 'TAG_CHANGES',
                label: 'Bad tags available in the cabinet (Critical Priority)',
                severity: 'Critical',
            },
            {
                type: 'TAG_CHANGES',
                label: 'Too many bad tags appeared in the cabinet (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'TAG_APPEARED_OUT_OF_REFILL',
                label: 'New products or tags placed into the cabinet but not in the refill process (Critical priority)',
                severity: 'Critical',
            },
        ],
    },
    {
        name: 'Payment System',
        types: [
            {
                type: 'MYPOS_DEVICE_DISCONNECTED',
                label: 'myPOS payment device is disconnected (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'MYPOS_DEVICE_COMMUNICATION_ERROR',
                label: 'myPOS payment device is connected but reporting error (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'CABINET_STATUS_IS_OOS_PAYMENT_PROVIDER',
                label: 'Payment provider is out of service (Out of Service priority)',
                severity: 'OoS',
            },            
            {
                type: 'NAYAX_DEVICE_NOT_READY',
                label: 'Nayax payment device is not ready (Out of Service priority)',
                severity: 'OoS',
            },            
            {
                type: 'NAYAX_DEVICE_NOT_READY',
                label: 'Nayax payment device is not ready',
                severity: 'Urgent',
            },
            {
                type: 'SOLD_PRODUCT_IN_INVENTORY',
                label: 'Already sold product appeared in cabinet inventory (Critical priority)',
                severity: 'Critical',
            },
            {
                type: 'ANTENOR_DEVICE_DISCONNECTED',
                label: 'Axis/Ingenico terminal not connected',
                severity: 'Urgent'
            }
        ],
    },
    // {
    //     name: 'Network',
    //     types: [
    //
    //     ],
    // },
    {
        name: 'Reader and Antenna',
        types: [
            {
                type: 'READER_IS_DOWN',
                label: 'RFID reader in the cabinet is not working (Urgent Priority)',
                severity: 'Urgent',
            },
            {
                type: 'READER_IS_DOWN',
                label: 'RFID reader in the cabinet is not working (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'ANTENNA_DOWN',
                label: 'RFID antenna in cabinet is not working (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'ANTENNA_DOWN',
                label: 'RFID antenna in cabinet is not working (Urgent Priority - for Industrial Devices)',
                severity: 'Urgent',
            },
            {
                type: 'ANTENNA_DISCONNECTED',
                label: 'RFID antenna in cabinet is disconnected (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'SID_HEALTH_NOT_AVAILABLE',
                label: 'Reader health report is not available (Urgent priority - for Industrial Devices)',
                severity: 'Urgent',
            },
            {
                type: 'READER_CONFIG_ERROR',
                label: 'RFID reader configuration failed and it is not working (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'RFID_READER_DOWN',
                label: 'RFID reader is down (Urgent priority - for Industrial Devices)',
                severity: 'Urgent',
            },
        ],
    },
    {
        name: 'Cabinet status',
        types: [
            {
                type: 'LOCK_MALFUNCTION',
                label: 'Locking system or lock sensor has a problem',
                severity: 'Urgent',
            },
            {
                type: 'DOOR_OPENED_TOO_LONG',
                label: 'Cabinet door stayed open for too long time (Critical priority)',
                severity: 'Critical',
            },
            {
                type: 'UI_IS_DOWN',
                label: 'Cabinet screen is not working (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'DOCKER_DOWN',
                label: 'Docker containers on cabinet backend are down (Informative priority)',
                severity: 'Informative',
            },
            {
                type: 'DEVICE_STATUS',
                label: 'Device Online/Offline status (Out of Service priority)',
                severity: 'OoS',
            },
            {
                type: 'DIGITWIN_STATUS',
                label: "Device's Digitwin Online/Offline status (Out of Service priority)",
                severity: 'OoS',
            },
        ],
    },
];
